<form>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>{{label}}</mat-label>
    <input matInput placeholder="Select Agent" [matAutocomplete]="auto" [formControl]="_form">
  </mat-form-field>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
    (optionSelected)="selectAgent($event.option.value)">
    <mat-option *ngIf="IsLoading$ | async">
      <lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator>
    </mat-option>
    <ng-container *ngIf="!(IsLoading$ | async)">
      <mat-option *ngFor=" let x of Agents$ | async " [value]="x" title="{{x.firstName}} - {{x.lastName}}">
        {{x.firstName}} {{x.lastName}}
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</form>